declare const __AIIR_FUNCTIONS_NAMESPACE__: string;

/** Injected from the manifest selected for this build; standalone previews use production naming. */
export const CUSTOM_FUNCTIONS_NAMESPACE =
  typeof __AIIR_FUNCTIONS_NAMESPACE__ === "string" ? __AIIR_FUNCTIONS_NAMESPACE__ : "AIIR";
